import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { VariablesComponent } from '@app/authorized/project/variables/variables.component';

@NgModule({
    imports: [SharedModule],
    declarations: [VariablesComponent],
    entryComponents: [VariablesComponent],
    exports: [VariablesComponent]
})
export class VariablesModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/variables/variables.module.ts